import { render, staticRenderFns } from "./SituationDetail.vue?vue&type=template&id=6b30e304&"
import script from "./SituationDetail.vue?vue&type=script&lang=js&"
export * from "./SituationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports